import { Provider } from "react-redux";
import Footer from "./app/components/Footer";
import Header from "./app/components/Header";
import Routes from "./app/routes";
import store from "./app/store";

const App = () => {
  return (
    <>
      <Provider store={store}>        
        <Header />
        <div>
          <Routes />
        </div>
        <Footer />
        <div className="copy-right">
            <span>© Superintendencia de industria y Comercio. Todos los derechos reservados.</span>
            <span>Política de uso de contenido página web. Política Editorial. Aviso de Privacidad. Creditos Notificaciones Judiciales.</span>
        </div>
      </Provider>
    </>
  );
};

export default App;
